import useMediaQuery from 'usehooks-ts/dist/esm/useMediaQuery/useMediaQuery'

export default function useMediumMobileMediaQuery() {
  return useMediaQuery(`(min-width: ${0}px) and (max-width: ${450}px) `)
}
